import { useState } from 'react';
import { Box, Button } from '@mui/material';
import './saveDraft.scss'

const SaveDraft = ({draft, setDraft, submit}) => { 
  const [name, setName] = useState(draft?.title || '');
  const [description, setDescription] = useState(draft?.description || '');
  const [alert, setAlert] = useState(null);

  const handlesaveDraft = async () => {
    const draftName = name.trim();
    if (!draftName.length) {
      setAlert('Enter a name for your Timeline artist');
      return;
    }
    const newDraft = {
      ...draft,
      title: draftName,
      description: description,
    }
    setDraft(newDraft);
    submit(newDraft)
  };
  

  const handleChangeName = (e) => {
    setAlert(null);
    setName(e.target.value);
  };

  return (
    <>
      <Box
        style={{
          width: "100%",
          height: "77%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          className="custom-input-container"
          style={{ height: "30%", width: "100%" }}
        >
          <label className="custom-input-label">TimeLine project name</label>
          <input
            type="text"
            placeholder="TIMELINE"
            className={`custom-input ${alert? 'error' : ''}`}
            style={{ height: "100%" }}
            value={name}
            onChange={handleChangeName}
          />
          {alert && <div className="alert">{alert}</div>}
        </div>
        <div
          className="custom-input-container"
          style={{ height: "50%", width: "100%" }}
        >
          <label className="custom-input-label">Description</label>
          <textarea
            type="text"
            placeholder="(Optional)"
            className="custom-input"
            style={{ height: "100%", Width: "100%", resize: "none" }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
      </Box>
      <Button className="button-save" onClick={handlesaveDraft}>save</Button>
    </>
  )
}

export default SaveDraft